import { initFilterExpression } from '../../model/filterExpressionUtils';

(function () {
	'use strict';

	var NUMOFCHARTS = 4;

	angular.module('mx.SolutionBuilderAgent').directive('mxComboChart', MxComboChartDirective);

	MxComboChartDirective.$inject = ['$injector', 'mx.SolutionBuilderAgent.BaseChartService'];

	function MxComboChartDirective($injector, baseChartService) {
		var directive = baseChartService.mxBaseChartDirective($injector);

		directive.controller = MxComboChartCtrl;

		for (var i = 1; i <= NUMOFCHARTS; i++) {
			var newDefinitions = {};

			newDefinitions['chart' + i + 'Data'] = '=?';
			newDefinitions['chart' + i + 'Type'] = '@';
			newDefinitions['chart' + i + 'Title'] = '@';
			newDefinitions['chart' + i + 'LegendFieldName'] = '@';
			newDefinitions['chart' + i + 'ValueFieldName'] = '@';
			newDefinitions['chart' + i + 'IndividualYAxis'] = '@';

			newDefinitions['chart' + i + 'EntityClass'] = '@';
			newDefinitions['chart' + i + 'ColumnDefinition'] = '@';
			newDefinitions['chart' + i + 'EntityType'] = '@';
			newDefinitions['chart' + i + 'ObjectId'] = '@';
			newDefinitions['chart' + i + 'SelectedItem'] = '=?';

			angular.extend(directive.bindToController, newDefinitions);
		}

		var baseLink = directive.link;

		directive.link = function (scope, element, attrs, ctrl) {
			if (typeof baseLink === 'function') {
				baseLink(scope, element, attrs, ctrl);
			}

			if (typeof scope.vm.dataWatcher === 'function') {
				scope.vm.dataWatcher();
			}

			scope.vm.debouncedAllDataWatcher = $.debounce(500, function () {
				scope.$evalAsync(function () {
					scope.vm.hasData = Object.keys(scope.vm.hasDataChart).some(function (i) {
						return scope.vm.hasDataChart[i];
					});

					if (scope.vm.hasData) {
						scope.vm.dataChanged = true;
						scope.vm.requestChartRerender();
					} else if (scope.vm.chartContainer.empty) {
						scope.vm.chartContainer.empty();
					}
				});
			});
			scope.vm.hasDataChart = {};
			for (var i = 1; i <= NUMOFCHARTS; i++) {
				scope.vm.hasDataChart[i] = false;
				addChartDataWatcher(scope, i);
			}
		};

		function addChartDataWatcher(scope, i) {
			scope.$watch(
				'vm.chart' + i + 'Data',
				function (items) {
					scope.vm.hasDataChart[i] = Array.isArray(items) && items.length > 0;
					scope.vm.debouncedAllDataWatcher();
				},
				true
			);
		}

		return directive;
	}

	MxComboChartCtrl.$inject = [
		'$injector',
		'$controller',
		'$scope',
		'$attrs',
		'$element',
		'mx.SolutionBuilderAgent.BaseChartService',
		'mx.shell.EventService',
		'mx.app.ColorService',
	];
	function MxComboChartCtrl($injector, $controller, $scope, $attrs, $element, baseChartService, eventService, colorService) {
		var vm = $controller('mx.SolutionBuilderAgent.MxBaseChartController', {
			$injector: $injector,
			$scope: $scope,
			$attrs: $attrs,
			$element: $element,
		});

		const adjustContrast = (color, level) => (mx.isEnhancedColorContrastMode ? colorService.enhanceColorContrast(color, undefined, level) : color);

		vm.$onInit = function () {
			for (let i = 1; i <= NUMOFCHARTS; i++) {
				initFilterExpression({
					propertyName: `chart${i}-filter-expression`,
					controlMxAtId: vm.mxAtId,
					$scope,
					$attrs,
					$element,
					controller: vm,
				});
			}
			initFields();
		};

		function initFields() {
			const fields = [
				{
					base: 'legendFieldName',
					combo: 'LegendFieldName',
				},
				{
					base: 'valueFieldName',
					combo: 'ValueFieldName',
				},
				{
					base: 'detailsFilterExpression',
					combo: 'FilterExpression',
				},
				{
					base: 'detailsEntityClassName',
					combo: 'EntityClass',
				},
				{
					base: 'detailsColumnDefinition',
					combo: 'ColumnDefinition',
				},
				{
					base: 'detailsEntityType',
					combo: 'EntityType',
				},
				{
					base: 'detailsObjectId',
					combo: 'ObjectId',
				},
				{
					base: 'detailsType',
					combo: 'DetailsType',
				},
			];

			function fieldGetter(i) {
				return function () {
					return vm['chart' + vm.currentSelectedChart + fields[i].combo];
				};
			}
			function fieldSetter(i) {
				return function (value) {
					if (fields[i].combo !== 'FilterExpression') {
						vm['chart' + vm.currentSelectedChart + fields[i].combo] = value;
					}
				};
			}
			for (let i = 0; i < fields.length; i++) {
				Object.defineProperty(vm, fields[i].base, {
					get: fieldGetter(i),
					set: fieldSetter(i),
				});
			}
		}

		vm.getChartConfig = function () {
			return baseChartService.getBaseChartConfig(vm).then(function (baseConfig) {
				const config = angular.extend({}, baseConfig);
				let i;

				config.legend = {
					enabled: true,
					layout: 'horizontal',
					align: 'center',
					verticalAlign: 'bottom',
					itemStyle: { color: adjustContrast(config.legend.itemStyle.color) },
					itemHoverStyle: config.legend.itemHoverStyle,
					itemHiddenStyle: config.legend.itemHiddenStyle,
				};

				vm.responsiveLegend = function () {};

				config.plotOptions.series.point.events.click = function () {
					for (i = 1; i <= NUMOFCHARTS; i++) {
						if (vm['chart' + i + 'Title'] === this.series.options.name) {
							vm.currentSelectedChart = i;
							vm.data = vm['chart' + i + 'Data'];
							break;
						}
					}
					vm.onChartClick(this);
				};

				var yAxis = [angular.copy(config.yAxis)];

				for (i = 1; i <= NUMOFCHARTS; i++) {
					var serie = createSerie(i);

					if (!serie) {
						continue;
					}

					if (vm['chart' + i + 'IndividualYAxis'] === 'true') {
						yAxis.push({
							gridLineWidth: 0,
							opposite: true,
							title: {
								enabled: null,
								style: { display: 'none' },
								text: serie.name || '',
							},
							labels: { style: { color: adjustContrast(window.Highcharts.getOptions().colors[i], 4.5) } },
						});

						serie.yAxis = yAxis.length - 1;
						serie.color = adjustContrast(window.Highcharts.getOptions().colors[i]);
					}

					config.series.push(serie);
				}

				if (yAxis.length >= config.series.length + 1) {
					yAxis[1] = angular.copy(config.yAxis);
					yAxis[0].visible = false;
				}

				config.yAxis = yAxis;

				config.series.sort(function (item, item2) {
					if (item.type === 'areaspline' && item2.type !== 'areaspline') {
						return -1;
					}
					if (item.type !== 'areaspline' && item2.type === 'areaspline') {
						return 1;
					}
					return 0;
				});

				config.lang.accessibility.axis.yAxisDescriptionPlural = vm.chartsI18n.a11y?.axis?.yAxisDescriptionPluralSimple;

				return config;
			});
		};

		eventService.subscribeTo(
			mx.shell.EventCodes.ThemeChanged,
			() => {
				$scope.vm.chart?.update({
					yAxis: $scope.vm.chart?.yAxis?.map((a, i) => ({ labels: { style: { color: adjustContrast(vm.chart?.yAxis[i].userOptions.labels.style.color, 4.5) } } })),
					series: $scope.vm.chart?.series?.map((s, i) => ({ color: adjustContrast(vm.chart?.series[i]?.color) })),
				});
			},
			$scope
		);

		function createSerie(i) {
			if (!vm['chart' + i + 'Data'] || vm['chart' + i + 'Data'].length === 0) {
				return;
			}

			return {
				type: vm['chart' + i + 'Type'],
				name: vm['chart' + i + 'Title'],
				data: vm['chart' + i + 'Data'].map(function (item) {
					return {
						name: item[vm['chart' + i + 'LegendFieldName']],
						y: item[vm['chart' + i + 'ValueFieldName']],
					};
				}),
			};
		}

		return vm;
	}
})();
